import React from 'react';
import LabelValue from 'components/ui/tailwind/label-value';
import { withTranslation } from 'react-i18next';
function InvoiceDocumentPreferences({ invoiceDocumentPreferences, invoiceDocumentPreferenceDocTypesMap, t, }) {
    return (React.createElement("div", null, invoiceDocumentPreferences.map((pref) => {
        var _a;
        return (React.createElement(LabelValue, { key: pref.slug, sequence: pref.sequence, value: t((_a = invoiceDocumentPreferenceDocTypesMap === null || invoiceDocumentPreferenceDocTypesMap === void 0 ? void 0 : invoiceDocumentPreferenceDocTypesMap[pref.slug]) === null || _a === void 0 ? void 0 : _a.localizationSlug) }));
    })));
}
export default withTranslation()(InvoiceDocumentPreferences);
